// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* * * * * * * * * * * * * * *\n\t\tdisplay sizes\n* * * * * * * * * * * * * * */\n/* * * * * * * * * * * * * * *\n\t\tsizes\n* * * * * * * * * * * * * * */\n/* * * * * * * * * * * * * * *\n\t\tcolors\n* * * * * * * * * * * * * * */\n/* fonts */\n/* borders */\n/* rest */\n/* new colors */\n.is-loading__PureImage_2PQbB {\n  height: 100%;\n  background-color: #bec1c3;\n  background-repeat: no-repeat;\n  background-position: center;\n  background-image: url(\"/img/loading.gif\");\n  min-height: 200px;\n}\n.broken-image__PureImage_Q0lp-,\n.missing-image__PureImage_31uyP {\n  padding: 40%;\n  background-color: #ededed;\n  opacity: 0.6;\n}\n", ""]);
// Exports
exports.locals = {
	"is-loading": "is-loading__PureImage_2PQbB",
	"isLoading": "is-loading__PureImage_2PQbB",
	"broken-image": "broken-image__PureImage_Q0lp-",
	"brokenImage": "broken-image__PureImage_Q0lp-",
	"missing-image": "missing-image__PureImage_31uyP",
	"missingImage": "missing-image__PureImage_31uyP"
};
module.exports = exports;
